import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../Common/Layout";
import { useNavigate } from "react-router-dom";

const CddList = () => {
  const [search, setSearch] = useState("");

  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const fetchCDD = async () => {
      try {
        const response = await axios.get(
          "https://irc.zentelex.com/api/cdd-receipts/all",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setData(response.data.data || []);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch Commodity Delivery Documents");
        setLoading(false);
      }
    };

    fetchCDD();
  }, []);

  const filteredData = data.filter((item) => {
    const keyword = search.toLowerCase();

    return (
      item.cddNo?.toLowerCase().includes(keyword) ||
      item.clientName?.toLowerCase().includes(keyword) ||
      item.commodityName?.toLowerCase().includes(keyword) ||
      item.documentDate?.toLowerCase().includes(keyword)
    );
  });

  const handleGoToPrint = (item) => {
    // Save selected delivery order in sessionStorage
    sessionStorage.setItem("deliveryorder", JSON.stringify(item));

    // Navigate to CDD Print page
    navigate("/cdd-print");
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <Layout>
      <div className="container-fluid">
        <h4 className="mb-4 fw-semibold">Commodity Delivery Documents</h4>

        {/* ================= DESKTOP TABLE ================= */}
        <div className="table-responsive d-none d-md-block">
          <div className="row mb-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search CDD No / Client / Commodity / Date..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>CDD No</th>
                <th>Date</th>
                <th>Client</th>
                <th>Commodity</th>
                <th>Bags</th>
                <th>Qty (MT)</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No records found
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.cddNo}</td>
                    <td>{item.documentDate}</td>
                    <td>{item.clientName}</td>
                    <td>{item.commodityName}</td>
                    <td>{item.noOfPack}</td>
                    <td>{item.weightMt}</td>
                    <td>
                      <button
                        className="btn btn-success btn-sm me-2"
                        onClick={() => alert(`Printing ${item.cddNo}`)}
                      >
                        Print
                      </button>

                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => navigate(`/cdd-print/${item.cddNo}`)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ================= MOBILE CARD VIEW ================= */}
        <div className="d-md-none">
          {filteredData.length === 0 ? (
            <p>No records found</p>
          ) : (
            filteredData.map((item, index) => (
              <div key={item.id} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <h6 className="fw-bold mb-2">
                    {index + 1}. {item.cddNo}
                  </h6>

                  <p className="mb-1">
                    <strong>Date:</strong> {item.documentDate}
                  </p>
                  <p className="mb-1">
                    <strong>Client:</strong> {item.clientName}
                  </p>
                  <p className="mb-1">
                    <strong>Commodity:</strong> {item.commodityName}
                  </p>
                  <p className="mb-1">
                    <strong>Bags:</strong> {item.noOfPack}
                  </p>
                  <p className="mb-2">
                    <strong>Qty:</strong> {item.weightMt} MT
                  </p>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success btn-sm w-50"
                      onClick={() => alert(`Printing ${item.cddNo}`)}
                    >
                      Print
                    </button>

                    <button
                      className="btn btn-primary btn-sm w-50"
                      onClick={() => navigate(`/cdd-print/${item.cddNo}`)}
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CddList;
